import { useNavigate } from 'react-router-dom';

import Button from './Button';

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col items-center justify-center min-h-[80vh] text-center px-4">
            <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
            <h2 className="text-2xl font-semibold text-gray-800 mb-6">Page Not Found</h2>
            <p className="text-gray-600 mb-8 max-w-md">
                The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
            </p>
            <div className="flex gap-4">
                <Button
                    variant="primary"
                    className="!px-8 !py-3 !text-lg bg-black hover:bg-gray-800"
                    onClick={() => navigate('/')}
                >
                    Go to Home
                </Button>
            </div>
        </div>
    );
};

export default NotFound;
